import BaseRestApi from '@/services/BaseRestApi';
import RestErreur from '@/utils/RestErreur';
import CoursDto from '@/models/titre/CoursDto';

export default class TitreRestApi extends BaseRestApi {
  get resource() { // eslint-disable-line
    return '/titre';
  }

  async getTauxChange(iniAnnee, insCurrency) {
    try {
      const ciAnnee = iniAnnee - 1; // Cas Tx moyen pas disponible pour l'année courante
      const coAnswer = await this.getApi().get(`${this.resource}/coursAnnuel/${ciAnnee}/${insCurrency}`);
      const ciStatus = coAnswer.status;

      if (ciStatus === 200) {
        if (coAnswer.data) {
          const dtoCours = CoursDto.getFactory(coAnswer.data);
          return dtoCours.valeurCloture;
        }
        return new RestErreur('Pas de taux de change pour pour cette année', coAnswer);
      }
      return new RestErreur('TitreRestApi:getTauxChange() warning', coAnswer);
    } catch (inexError) {
      return new RestErreur('TitreRestApi:getTauxChange() erreur', inexError);
    }
  }
}
